export const GET_BOOKINGS = gql`
  query GetBookings($filters: BookingFiltersInput, $pageInfo: PageInfoInput) {
    getBookings(filters: $filters, pageInfo: $pageInfo) {
      totalCount
      items {
        bookingId
        createdAt
        updatedAt
        bookingDurationInMinutes
        bookingStartTime
        bookingEndTime
        title
        description
        status
        activityLogId
        cancelledDate
        company {
          companyId
          companyName
        }
        applicant {
          applicantId
          firstName
          lastName
          phone
        }
        employee {
          employeeId
          firstName
          lastName
          phone
        }
        activityLog {
          activityLogId
          callDirection
          callType
          voiceAgent {
            name
          }
        }
      }
    }
  }
`

export const GET_BOOKINGS_COUNT = gql`
  query GetBookingsCount($filters: BookingFiltersInput!) {
    getBookingsCount(filters: $filters) {
      date
      count
    }
  }
`

export const CANCEL_BOOKING = gql`
  mutation CancelBooking($bookingId: String!) {
    cancelBooking(bookingId: $bookingId)
  }
`

export const MARK_BOOKING_AS_NO_SHOW = gql`
  mutation MarkBookingAsNoShow($bookingId: String!) {
    markBookingAsNoShow(bookingId: $bookingId) {
      bookingId
      status
    }
  }
`
